<template>
  <div class="reporting-main-section-sidebar flex-shrink-1 pt-4 px-3">
    <div class="sidebar-inner">
      <!-- Top section -->
      <div class="top-section">
        <h4 class="mb-1">Filters</h4>
        <hr />
        <tag-filter></tag-filter>
        <date-ticket-opened-filter></date-ticket-opened-filter>
        <date-ticket-resolved-filter></date-ticket-resolved-filter>
        <date-ticket-closed-filter></date-ticket-closed-filter>
        <agents-filter></agents-filter>
        <travel-consultants-filter></travel-consultants-filter>
        <status-filter></status-filter>
        <priority-filter></priority-filter>
        <difficulty-filter></difficulty-filter>
        <source-filter></source-filter>
        <caused-by-itg-error-filter v-if="false"></caused-by-itg-error-filter>
      </div>
      <!-- / Top section -->
      <!-- Bottom section -->
      <div class="bottom-section pt-3 pb-3">
        <a href="#" @click="runReport" class="btn btn-itg-dark btn-block">
          Run Report
        </a>
      </div>
      <!-- / Bottom section -->
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import DateTicketOpenedFilter from "./Filters/DateTicketOpenedFilter";
import AgentsFilter from "./Filters/AgentsFilter";
import StatusFilter from "./Filters/StatusFilter";
import PriorityFilter from "./Filters/PriorityFilter";
import DifficultyFilter from "./Filters/DifficultyFilter";
import SourceFilter from "./Filters/SourceFilter";
import DateTicketResolvedFilter from "./Filters/DateTicketResolvedFilter";
import DateTicketClosedFilter from "./Filters/DateTicketClosedFilter";
import CausedByItgErrorFilter from "./Filters/CausedByItgErrorFilter";
import TagFilter from "./Filters/TagFilter";
import TravelConsultantsFilter from './Filters/TravelConsultantsFilter.vue';

export default {
  name: "ReportingMainSectionSidebar",
  methods: {
    ...mapActions("reportEditor", {
      runReport: "runReport",
    }),
  },
  components: {
    CausedByItgErrorFilter,
    DateTicketClosedFilter,
    DateTicketResolvedFilter,
    DateTicketOpenedFilter,
    PriorityFilter,
    AgentsFilter,
    StatusFilter,
    DifficultyFilter,
    TagFilter,
    TravelConsultantsFilter,
    SourceFilter
  },
};
</script>

<style scoped lang="scss">
.reporting-main-section-sidebar {
  //width: 300px;
  width: 300px;
  background: #ebeff3;
  box-shadow: inset 10px 0 10px -8px #ebeff3;

  .sidebar-inner {
    height: 100%;
    display: flex;
    flex-direction: column;

    .top-section {
      flex-grow: 1;
      overflow-y: scroll;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
</style>